export default __webpack_public_path__ + "static/media/avada.58640968.png";